import React from 'react';

const Logo = ({ className = "w-12 h-12", textColor = "text-white" }) => {
  return (
    <div className={`${className} relative`}>
      <svg viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
        {/* Simple house/building icon */}
        <path 
          d="M50 15L20 40V85H80V40L50 15Z" 
          className="fill-current text-blue-600"
        />
        <path 
          d="M35 85V60H65V85" 
          className="fill-current text-cyan-500"
        />
        <circle cx="42" cy="50" r="4" className="fill-current text-white" />
        <circle cx="58" cy="50" r="4" className="fill-current text-white" />
      </svg>
    </div>
  );
};

export default Logo;
